(function () {
  'use strict';

  // UpCart's open shadow root isolates its controls from the theme stylesheet.
  // Keep the app's select and change handlers; only enhance its presentation.
  var stylesheet = document.currentScript.dataset.stylesheet;
  if (!stylesheet || !window.CSS || !CSS.supports('appearance', 'base-select')) return;

  var root;
  var observer;

  function installStyles() {
    if (root.querySelector('link[data-dw-upcart-select]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = stylesheet;
    link.dataset.dwUpcartSelect = '';
    root.appendChild(link);
  }

  function findCart() {
    var host = document.getElementById('upCart');
    var nextRoot = host && host.shadowRoot;
    if (nextRoot === root) return;
    if (observer) observer.disconnect();
    root = nextRoot;
    if (!root) return;
    installStyles();
    observer = new MutationObserver(installStyles);
    observer.observe(root, { childList: true });
  }

  findCart();
  // Attaching a shadow root does not emit a document mutation. UpCart can load
  // lazily or replace its host, so discover it without patching attachShadow.
  window.setInterval(findCart, 1000);
})();
